import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import scroll from 'quasar/src/utils/scroll.js';;
var getScrollTarget = scroll.getScrollTarget,
    setScrollPosition = scroll.setScrollPosition;
import { colorLuminance } from "../../../utils/utils";
import { calculateRating, getEmojiOptions, getExistingRatingByOption } from "../menuInsightHelpers/ratings";
import { shouldShowSubquestion } from "../menuInsightHelpers/rendering";
import { getSubquestionsForSubcategory } from "../menuInsightHelpers/getTypeDishes";
import { canLoadMoreItems } from "../../../functions/utils";
export default {
  name: 'MenuInsightsGroupedOffline',
  props: {
    allProductsAsInlineDishes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    products: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    question: {
      type: Object,
      required: true
    },
    searchResults: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      modal: false,
      searchBox: false,
      searchTerm: '',
      topLevelSearchActive: false,
      selectedMajorGroupItem: {},
      selectedTopLevelGroup: {},
      selectedListItems: [],
      selectedListItemsToShow: [],
      selectedDish: null,
      showSelectedDish: false,
      showingFamilyGroupLevel: true,
      productsToShow: this.products,
      loading: false,
      pageSize: 25,
      shouldShowSubquestion: shouldShowSubquestion
    };
  },
  computed: {
    emojiOptions: function emojiOptions() {
      return getEmojiOptions(this.question);
    },
    //! Why dont we just save the dish as well?
    selectedDishes: function selectedDishes() {
      var _this = this;

      var allDishes = this.allProductsAsInlineDishes;
      var dishes = allDishes.filter(function (option) {
        return !!_this.getResponsesByRef(option.ref);
      });
      return dishes;
    },
    overlay: function overlay() {
      return {
        color: colorLuminance(this.$store.getters['theme/theme'].primaryColor, -0.5)
      };
    },
    responses: function responses() {
      var answerStoreResponse = this.$store.getters['answers/responses'] || {};
      return answerStoreResponse["question".concat(this.question.id)] || [];
    },
    shownSelectedItems: function shownSelectedItems() {
      return this.selectedListItemsToShow;
    }
  },
  watch: {
    searchTerm: function searchTerm(val) {
      this.loading = true;
      this.$emit('search', val);

      if ((val || '').length === 0) {
        this.topLevelSearchActive = false;
      }
    },
    searchResults: function searchResults() {
      this.loading = false;
    }
  },
  mounted: function mounted() {
    if (this.products.length === 1) {
      this.showingFamilyGroupLevel = false;
      this.productsToShow = this.products[0].majorGroups;
    } else {
      this.productsToShow = this.products;
    }
  },
  methods: {
    onScroll: function onScroll(val) {
      // check to see if more items could be added to the shown items in the array
      var shouldLoadMore = canLoadMoreItems(val, this.selectedListItemsToShow, this.selectedListItems, this.$refs.questionsContentScrollContainer);

      if (shouldLoadMore) {
        var currentLastIndex = this.selectedListItemsToShow.length;
        var newItems = this.selectedListItems.slice(currentLastIndex, currentLastIndex + this.pageSize);
        this.selectedListItemsToShow = [].concat(_toConsumableArray(this.selectedListItemsToShow), _toConsumableArray(newItems));
      }
    },
    scrollToElement: function scrollToElement(id) {
      var el = document.getElementById(id);
      var target = getScrollTarget(el);
      var offset = el.offsetTop;
      var duration = 300;
      setScrollPosition(target, offset - 200, duration);
    },
    selectedCategory: function selectedCategory(item) {
      this.selectedTopLevelGroup = item;

      if (this.showingFamilyGroupLevel) {
        var _item$majorGroups$;

        this.selectedMajorGroupItem = item.majorGroups[0] || [];
        this.selectedListItems = ((_item$majorGroups$ = item.majorGroups[0]) === null || _item$majorGroups$ === void 0 ? void 0 : _item$majorGroups$.products) || [];
      } else {
        this.selectedMajorGroupItem = item;
        this.selectedListItems = item.products;
      } // now split the data into more manageable chunks to render


      this.selectedListItemsToShow = this.selectedListItems.slice(0, this.pageSize);
    },
    closeSelectionModal: function closeSelectionModal() {
      this.modal = false;
      this.selectedMajorGroupItem = {};
      this.selectedTopLevelGroup = {};
      this.selectedListItemsToShow = [];
    },
    subcategorySelected: function subcategorySelected(item) {
      this.selectedMajorGroupItem = item;
      this.selectedListItemsToShow = item.products;
    },
    handleEmojiClicked: function handleEmojiClicked(value, item) {
      // For some reason this doesn't end up getting called in circumstances where it is newly selected, which is strange, but I won't rely on this to implement a solution here as it shouldn't be the case.  I won't bother fixing this now as no functionality currently requires this call to be made in those cases, but it is worth keeping note of.
      // if no item or value provided, ditch out
      if (!value || !item) {
        return;
      } // if follow up questions allowed, ditch out, (although in the future this functionality might be desied)


      if (this.question.followUpQuestion) {
        return;
      } // double check that there is an existing rating for item, and that the aspectRatingId matches the value provided


      var rating = getExistingRatingByOption(item, this.responses); // if no rating or no match, ditch out

      if (!rating || rating.aspectRatingId !== value) {
        return;
      } // clear out rating


      this.clearDish(item);
    },
    //! WHY ARE WE PASSING THE SAME VALUE TWICE UNDER TWO DIFFERENT KEYS
    handleResponse: function handleResponse(value, context) {
      var calculatedRating = calculateRating(value, context, this.responses);

      if (context.source === 'selectedDishEmoji' || !calculatedRating) {
        return; // not currently supporting inline selection in the 'selected dishes' area
      }

      var question = this.question;
      this.$store.dispatch('answers/upsertMenuInsightResponse', {
        question: question,
        rating: calculatedRating
      });
    },
    openModal: function openModal(product) {
      var questions = getSubquestionsForSubcategory(this.question, product);
      this.selectedDish = _objectSpread({}, product || {});
      this.selectedDish.subQuestions = [];
      this.selectedDish.subQuestions = questions;
      this.showSelectedDish = true;
    },
    closeModal: function closeModal(closeSelectedDishModal) {
      this.selectedDish = null;
      this.showSelectedDish = false;

      if (!closeSelectedDishModal) {
        this.modal = false;
      }
    },
    getComments: function getComments(dish) {
      if (!((dish || {}).subQuestions || {}).length) {
        return false;
      }

      var rating = this.getResponsesByRef(dish.ref);
      var hasComments = rating ? dish.subQuestions.some(function (subQuestion) {
        return subQuestion && subQuestion.type === 'fib-comments' && rating.comment;
      }) : false;
      return hasComments;
    },
    getFibEmojiValue: function getFibEmojiValue(option) {
      var rating = this.getResponsesByRef(option.ref);
      return rating ? rating.aspectRatingId : null;
    },
    getSubQuestionValue: function getSubQuestionValue(subQuestion, option) {
      var rating = this.getResponsesByRef(option.ref);

      if (!rating) {
        return null;
      }

      var val = null;

      switch (subQuestion.type) {
        case 'fib-comments':
          val = rating.comment;
          break;

        case 'fib-select-option':
          val = rating.tags;
          break;
      }

      return val;
    },
    clearDish: function clearDish(dish) {
      // if no dish, ditch out
      if (!dish) {
        return;
      } // if no dish ref, or dish id, ditch out


      var id = dish.ref || dish.id;

      if (!id) {
        return;
      }

      this.selectedDish = null;
      this.showSelectedDish = false;
      this.$store.dispatch('answers/clearMenuInsightResponse', {
        question: this.question,
        id: id
      });
    },
    modalSaveButtonDisabled: function modalSaveButtonDisabled(dish) {
      var dishRated = this.getResponsesByRef(dish.ref);
      return !dishRated;
    },
    getResponsesByRef: function getResponsesByRef(ref) {
      return this.responses.find(function (r) {
        return r.ref == ref;
      });
    },
    onClearSearch: function onClearSearch() {
      this.topLevelSearchActive = false;
      this.$emit('clear-search');
    }
  }
};